import { Button } from 'primereact/button';
import { anulaDotacion } from '../../services/empleado/EmpleadoDotacionService';
import { useRef, useState } from 'react';
import { Toast } from 'primereact/toast';

const DotacionBorrar = ({ datosDotacion, funcCerrarBorra }) => {
    const [procesa, setProcesa] = useState(false);

    const borraToast = useRef()
    
    const pausa = (ms) => new Promise((res) => setTimeout(res, ms));

    const borrarDotacion = async () => {
        try {
            setProcesa(true);
            const data = await anulaDotacion(datosDotacion.dotacionId);
            borraToast.current.show({
                severity: 'success',
                summary: 'Eliminado',
                detail: 'Dotacion Eliminada con Exito'
            });
        } catch (err) {
            borraToast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Error al eliminar Dotacion'
            });
            console.error('Error al borrar la Dotación');
        } finally {
            //
            await pausa(1000);
            setProcesa(false);
            funcCerrarBorra();
        }
    };

    return (
        <div className="formgrid grid p-fluid mb-3">
            <Toast ref={borraToast} />
            <div className="field col-12 md:col-6">
                <span className="font-black">Grupo Dotacion: </span>
            </div>
            <div className="field col-12 md:col-6">
                <span>Item Dotacion: </span>
            </div>
            <div className="field col-12 md:col-6">
                <span className="inline-block w-full bg-gray-100 border border-gray-300 text-gray-600 p-2 rounded-md text-base shadow-inner">
                    {datosDotacion.grupoDotacionNombre}
                </span>
            </div>
            <div className="field col-12 md:col-6">
                <span className="inline-block w-full bg-gray-100 border border-gray-300 text-gray-600 p-2 rounded-md text-base shadow-inner">
                    {datosDotacion.tipoDotacionNombre}
                </span>
            </div>
            <div className="field col-12 md:col-6">
                <span className="font-black">Cantidad: </span>
            </div>
            <div className="field col-12 md:col-6">
                <span>Fecha Entrega: </span>
            </div>
            <div className="field col-12 md:col-6">
                <span className="inline-block w-full bg-gray-100 border border-gray-300 text-gray-600 p-2 rounded-md text-base shadow-inner">
                    {datosDotacion.cantidad}
                </span>
            </div>
            <div className="field col-12 md:col-6">
                <span className="inline-block w-full bg-gray-100 border border-gray-300 text-gray-600 p-2 rounded-md text-base shadow-inner">
                    {datosDotacion.fechaEntregaLit}
                </span>
            </div>
            <div className="field col-12 md:col-6">
                <span className="font-black">Estado Dotacion: </span>
            </div>
            <div className="field col-12 md:col-6">
                <span>Estado Entrega: </span>
            </div>
            <div className="field col-12 md:col-6">
                <span className="inline-block w-full bg-gray-100 border border-gray-300 text-gray-600 p-2 rounded-md text-base shadow-inner">
                    {datosDotacion.estadoNombre}
                </span>
            </div>
            <div className="field col-12 md:col-6">
                <span className="inline-block w-full bg-gray-100 border border-gray-300 text-gray-600 p-2 rounded-md text-base shadow-inner">
                    {datosDotacion.estadoDotacionNombre}
                </span>
            </div>
            <div className="field col-12 md:col-6">
                <span className="font-black">Fecha Devolucion: </span>
            </div>
            <div className="field col-12 md:col-6">
                <span>Estado Devolucion: </span>
            </div>
            <div className="field col-12 md:col-6">
                <span className="inline-block w-full bg-gray-100 border border-gray-300 text-gray-600 p-2 rounded-md text-base shadow-inner">
                    {datosDotacion.fechaDevolucionLit}
                </span>
            </div>
            <div className="field col-12 md:col-6">
                <span className="inline-block w-full bg-gray-100 border border-gray-300 text-gray-600 p-2 rounded-md text-base shadow-inner">
                    {datosDotacion.estadoDotacionDevolucionNombre}
                </span>
            </div>
            <div className="field col-12 md:col-4"></div>
            <div className="field col-12 md:col-4">
                <Button
                    label="Borrar"
                    className="p-button-danger"
                    onClick={borrarDotacion}
                    loading={procesa}
                />
            </div>
            <div className="field col-12 md:col-4"></div>
        </div>
    );
};

export default DotacionBorrar;
